import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGN_PROMO_CODE_DETAIL } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignPromoCodeDetail() {
  const isSubmitting = ref(false);

  const fetchCampaignDetailByPromoCode = async (promoCode) => {
    if (isSubmitting.value) return { success: false };

    isSubmitting.value = true;

    try {
      const path = CATEGORY_COMMISSION_CAMPAIGN_PROMO_CODE_DETAIL.replace(
        '{promoCode}',
        encodeURIComponent(promoCode.trim()),
      );

      const response = await Req.get(path, null, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (!response.status || response.status !== 200) {
        throw new Error('Network response was not OK');
      }

      return {
        success: true,
        data: response.data,
        error: null,
      };
    } catch (error) {
      const errors = error?.data?.errors || [];
      const firstError = errors[0] || {};

      return {
        success: false,
        data: null,
        error: {
          title: firstError?.title || 'Hata',
          message: firstError?.message || 'Bir hata oluştu.',
          code: firstError?.code || null,
          campaignId:
            firstError?.detail?.campaignId || firstError?.campaignId || null,
        },
      };
    } finally {
      isSubmitting.value = false;
    }
  };

  return {
    isSubmitting,
    fetchCampaignDetailByPromoCode,
  };
}
